// useElementSize.ts
import { useLayoutEffect, useRef, useState } from "react";
import useResizeObserver from "@react-hook/resize-observer";
export default function useElementSize() {
    var target = useRef(null);
    var _a = useState({
        width: 0,
        height: 0
    }), size = _a[0], setSize = _a[1];
    var setRoundedSize = function (_a) {
        var width = _a.width, height = _a.height;
        setSize({ width: Math.round(width), height: Math.round(height) });
    };
    useLayoutEffect(function () {
        target.current && setRoundedSize(target.current.getBoundingClientRect());
    }, [target]);
    useResizeObserver(target, function (entry) {
        var _a = entry.contentBoxSize[0], width = _a.inlineSize, height = _a.blockSize;
        setRoundedSize({ width: width, height: height });
    });
    return [target, size];
}
